import React, { Component} from 'react';
import { translate } from 'react-i18next';
import {Typeahead} from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import { rejectReasons, functionalCriterial,clinicHistoryValuesOffer,donationNotesByOffer } from '../../../libs/services';
//import Form from '../components/register/Form';
import { useState } from 'react';
import { Button } from 'react-bootstrap/lib/InputGroup';
import moment from 'moment';
const {htmlToText} = require('html-to-text');
class RejectionReason extends Component{
    
    constructor(props){
        super(props);
        this.keyUpRejectionDay = this.keyUpRejectionDay.bind(this);
        this.getNotes = this.getNotes.bind(this);
        this.showValoration = this.showValoration.bind(this);
        var aux_date = new Date();
        this.state={
            don_abr_rech:{},
			rejection_reasons:[],
			donation_status:'',
			
			rejection_reasons_id:'',
			dateRejection:'',
			rejection_type:'',
			days:'',
			DON_EDIT_REJECT_DAYS:false,

			indiceRejection: -1,
            rejection_description:"",
            rejection_days:'',
            description:"",
            valoration:"",
            observa:"",
            modal_notes:[],
            date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
            status_id:'',
            //show_valoration:false
        }
        
    }
    async componentDidMount(){
        sessionStorage.removeItem('indice_rejection');
		sessionStorage.removeItem('rejection_days');
		sessionStorage.removeItem('rejection_description');
        sessionStorage.removeItem('tarjet_value');
        sessionStorage.removeItem('show_valoration');
        //console.log("description: "+this.state.rejection_description+" days: "+this.state.rejection_days)
        
        var response = await functionalCriterial('don_abr_rech');
		if(response !== undefined){
			this.setState({
				don_abr_rech: response
			});
		}	
        response = await rejectReasons('actives');
		if(response !== undefined){
            response.forEach((res)=>{
                res.values = res.name
            });
			this.setState({rejection_reasons:response});
			//console.log("razones de rechazo:",this.state.rejection_reasons[0].name);
		}
		response = await functionalCriterial('DON_EDIT_REJECT_DAYS');
		if(response !== undefined){
			if (response.value === "NO") { 
				this.setState({
					DON_EDIT_REJECT_DAYS: true
				});
			} else {
				this.setState({
					DON_EDIT_REJECT_DAYS: false
				});
			}
		}
        console.log(sessionStorage.getItem('offer'));
        if (sessionStorage.getItem('offer')!== null){
        response = await clinicHistoryValuesOffer(sessionStorage.getItem('offer'));
        console.log("response: ",response);
        if(response !== null && response !== 'Permiso Denegado.' && response !== undefined){
            //.log(this.state.rejection_reasons)
            //console.log(response.status.process)
            //sessionStorage.setItem('status_id',response.status.id);
			this.setState({
				            valoration: response.status !== undefined && response.status !== null ?
								 response.status.status === 'DIFERIDO' || response.status.status === 'REJECT' ?
									'NO_APTO'
								: response.status.status
							: "",
                            
                            donation_status:response.status !== undefined && response.status !== null ? response.status.status : "", 
                            update: response.general !== undefined && response.general !== null ? true : false,
                            
                            clinic_history_id: response.general !== undefined && response.general !== null ? response.general.id :"",
                            
                            last_donation_date: response.general !== undefined && response.general !== null ? 
                                                    response.general.last_donation_date !== null ?
                                                        moment(response.general.last_donation_date).format('YYYY-MM-DD')
                                                    : ""
                                                : "",
                            last_donation_time:response.general !== undefined && response.general !== null ? response.general.last_donation_time : "",
                            });
                            //sessionStorage.setItem('tarjetValue',this.state.valoration)
                            this.getNotes();

                            if(this.state.donation_status === "REJECT" || this.state.donation_status === "DIFERIDO" || this.state.donation_status === 'NOT_RESULTS'){
                                var new_date = moment(response.status.timestamp_date).add('days', parseInt(response.general.rejections_days));
                
                                this.setState({ 
                                    date:new_date.format('YYYY-MM-DD'),
                                    rejection_reasons_id:response.general.rejection_reasons_id,
                                    rejection_days:parseFloat(response.general.rejections_days),
                                    donation_status: response.general.rejections_days === 0 || response.general.rejections_days === null ?
                                                        'REJECT'
                                                    : response.general.rejections_days > 0 ? 'DIFERIDO' : null,
                                });				
                                    sessionStorage.setItem('rejection_days',response.general.rejections_days);
                                    sessionStorage.setItem('indice_rejection',response.general.rejection_reasons_id);
                                    sessionStorage.setItem('rejection_description',response.general.rejection_description);
                                    sessionStorage.setItem('targetValue',response.status.status)
                                setTimeout(function(){
                                    for(var i =0; i < this.state.rejection_reasons.length;i++){
                                        if(parseInt(response.general.rejection_reasons_id,10) === this.state.rejection_reasons[i].id){
                                            this.setState({
                                                rejection_description:this.state.rejection_reasons[i].name,
                                                indiceRejection: i
                                            });
                
                                        }
                                    }
                                    
                                }.bind(this), 500);
                                
                            }
                            //console.log("state: ",this.state);
                        }
                    }else {
                        this.setState({
                            //valoration: 'NO_APTO'
                        });
                        sessionStorage.setItem('tarjet_value',this.state.valoration);
                    }
                        
    }
    
    componentWillUnmount() {
		
	}
    async getNotes(actives = true,load=false){
        if(load){
			this.props.waiting.handleShow('Cargando...');
		}
        var response = await donationNotesByOffer(sessionStorage.getItem('offer'), actives);
        //console.log(response);
        if(load){
			this.props.waiting.handleClose();
		}
                        if(response !== undefined){
                            var observa = "";
                            var modal_notes = []
                            response.res.map((res)=>{
                                //console.log(res.note.proces_type);
                                var screen = '';
                
                                if(res.note.proces_type === 'EXTRACION'){
                                    screen = 'EXTRACIÓN';
                                }
                
                                if(res.note.proces_type === 'CLINIC_HISTORY'){
                                    screen = 'HISTORIA CLINICA';
                                }
                
                                if(res.note.proces_type === 'REGISTER'){
                                    screen = 'REGISTRO';
                                }
                
                                if(res.note.proces_type === 'LABORATORY'){
                                        screen = 'LABORATORIO';
                                    }
                
                                observa += ' -- '+screen+' -- \n'+
                                             '** '+res.medical_staff+'\t'+
                                             moment(res.note.timestamp).format('DD/MM/YYYY HH:mm')+'\n'+
                                             htmlToText(res.note.note)+'\n\n';
                
                                modal_notes.push({
                                    screen: screen,
                                    id: res.note.id,
                                    user_date: res.medical_staff+' - '+moment(res.note.timestamp).format('DD/MM/YYYY HH:mm'),
                                    note: htmlToText(res.note.note),
                                    active: res.note.active
                                });
                                
                            })
                            
                            this.setState({notes:observa, modal_notes: modal_notes});
                            
                        }
    }
    
    handleTypeAheadChange = name => values => {

        if(values.length > 0){
        	var index = this.state.rejection_reasons.findIndex(obj => obj.id === values[0].id)
            //console.log("name: "+JSON.stringify(values[0].name));
            //console.log("id rejection: "+JSON.stringify(values[0].id))
        	this.setState({
        		[name]: values[0].id,
        		donation_status: values[0].rejection_days === 0 || values[0].rejection_days === null ?
        					'REJECT'
        				: values[0].rejection_days > 0 ? 'DIFERIDO' : null,
        		indiceRejection:index,
        		rejection_days: values[0].rejection_days,
        		rejection_description:values[0].name,
        	});
            
        	sessionStorage.setItem('rejection_description', values[0].name)
            sessionStorage.setItem('indice_rejection',values[0].id)
            sessionStorage.setItem('rejection_days',values[0].rejection_days)
            
        	var days = Math.round(values[0].rejection_days);
			var new_date = this.addDays(new Date(),days);
			this.setState({ 
				date:new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2)
			});
            var dif= 'DIFERIDO';
            var rej = 'REJECT';
            //console.log("reejction inicio"+sessionStorage.getItem('rejection_days'))
            if(values[0].rejection_days === 0 || values[0].rejection_days === null){
                sessionStorage.setItem('tarjet_value',rej);
                console.log(sessionStorage.getItem('tarjet_value'));
            }
            if(values[0].rejection_days > 0){
                sessionStorage.setItem('tarjet_value',dif);
                console.log(sessionStorage.getItem('tarjet_value'));
            }
        }
        //console.log(this.state.donation_status);
        //sessionStorage.setItem('tarjet_value',this.state.donation_status)
 	}
     
     valorationSelected = (event) => {
		this.setState({[event.target.name]:event.target.value,rejection_reasons_id:""});
        //console.log(event.target.value)
        //sessionStorage.setItem('targetValue',event.target.value);
		if(event.target.value === 'NO_APTO'){
			this.getRejectionReasons('actives');
		}else{
			this.setState({donation_status: event.target.value});
		}
        if(event.target.value==='PENDING'){
            sessionStorage.setItem('tarjet_value',event.target.value)
            sessionStorage.removeItem('indice_rejection');
		sessionStorage.removeItem('rejection_days');
		sessionStorage.removeItem('rejection_description');
        }
        if(event.target.value==='ACCEPT'){
            sessionStorage.setItem('tarjet_value',event.target.value)
            sessionStorage.removeItem('indice_rejection');
		sessionStorage.removeItem('rejection_days');
		sessionStorage.removeItem('rejection_description');
        }
                            console.log("VALOR: ",event.target.value);
                            console.log("id: ",event.target.id)
		if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(event.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
        sessionStorage.removeItem('indice_rejection');
		sessionStorage.removeItem('rejection_days');
		sessionStorage.removeItem('rejection_description');
		
		//sessionStorage.removeItem('status_id');
	}
	async getRejectionReasons(option){
		var response = await rejectReasons(option);
		if(response !== undefined){
			this.setState({rejection_reasons:response});
            //console.log(this.state.rejection_reasons_id);
		}	
	}

    

    handleChangeInput = (event, index, value) => {
	    this.setState({
	      [event.target.name]: event.target.value
	    });
        //console.log("evento: "+event.target.value);
	    if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
            //console.log("control: "+control);
			if(event.target.value !== ""){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}else{
				control.classList.add('error');
			}
		}
	}
    keyUpRejectionDay(event){
    	var days = Math.round(this.state[event.target.name]);
        //console.log("dias rechazo: "+days)
		var new_date = this.addDays(new Date(),days);
        sessionStorage.setItem('rejection_days', days)
        //console.log("rejection keyup: "+sessionStorage.getItem('rejection_days'))
		this.setState({ 
			date:new_date.getFullYear()+'-'+("0" + (new_date.getMonth() + 1)).slice(-2)+'-'+("0" + new_date.getDate()).slice(-2)
		});
	}
    addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
		//console.log(result);
        return result;
    }
    calculateRefusalDays = (event) => {
		var days = this.daysBetween(new Date(), new Date(event.target.value));
		this.setState({[event.target.name]:event.target.value,rejection_days:days});
		if(days < 0){//Error
			document.getElementById(event.target.id).classList.add('error');
			swal('Error', 'No se permiten periodos de rechazo negativos','error');

		}else{
			document.getElementById(event.target.id).classList.remove('error');
		}
	}
    //handleChange = e => this.setState({ [e.target.name]: e.target.value });
showValoration=(e)=>{
    if (e.target.checked) {
        sessionStorage.setItem('show_valoration',"true");
        console.log(sessionStorage.getItem('show_valoration'))
        this.setState({valoration:"NO_APTO"});
    }else{
        sessionStorage.setItem('show_valoration',"false");
        console.log(sessionStorage.getItem('show_valoration'))
        
        sessionStorage.removeItem('indice_rejection');
		sessionStorage.removeItem('rejection_days');
		sessionStorage.removeItem('rejection_description');
        this.setState({valoration:""});
    }
    this.setState({show_valoration:e.target.checked})
}
    render(){
        
          const { t } = this.props
        return(
            <><legend>{t('content.modal_hc.conclusion')}</legend><div className="col-xs-12 form-group conclusion">
                <div className="col-xs-12 col-md-2" style={{ padding: "2px 2px 2px 8px" }}>
                <div className="col-xs-12 col-md-12" style={{ padding: "2px 2px 2px 8px" }}>
                    <span>Valorar </span>
                <input
                  type="checkbox"
                  checked={this.state.show_valoration}
                  onChange={(e) => this.showValoration(e)}
                />
                </div>
                <div style={{ display: this.state.show_valoration ? 'block' : 'none' }}>
                    <span className="size-min">{t('content.modal_hc.result')}</span>

                    <select className="form-control" value={this.state.valoration}
                    disabled
                        //disabled={(!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||this.state.exist_extraction}
                        onChange={this.valorationSelected.bind()} name="valoration" id="valoration">
                        <option value="" disabled>Seleccionar...</option>
                        <option value="ACCEPT">APTO</option>
                        <option value="PENDING">PENDIENTE</option>
                        <option value="NO_APTO">NO APTO</option>
                        <option value="NOT_RESULTS">RECHAZADO SIN VALORAR</option>
                    </select>
                    </div>
                    </div>
                            {this.state.valoration === "NO_APTO" || this.state.valoration === "NOT_RESULTS" ?
                    <div style={{ padding: '28px', display: this.state.show_valoration ? 'block' : 'none'}}>
                        <div className="col-xs-12 col-md-5" style={{ padding: "2px 2px 2px 8px" }}>

                            <b><span className="size-min">{t('content.modal_hc.rejection_reasons')}(*)</span></b>

                            {this.state.don_abr_rech.value === "NO" ?

                                <Typeahead
                                    //disabled={(!this.props.task_register.create && 
                                    //!this.props.task_register.update)||this.state.exist_extraction}
                                    labelKey={(option) => `${option.name}`}
                                    minLength={0}
                                    name="rejection_reasons_id"
                                    id="rejection_reasons_id"
                                    inputProps={{
                                        required: this.state.don_abr_rech.value === "NO" ||
                                            this.state.valoration === 'NO_APTO' || this.state.valoration === 'NOT_RESULTS',
                                        autoComplete: "off",
                                        name: 'rejection_reason',
                                        id: 'rejection_reason'
                                    }}
                                    options={this.state.rejection_reasons}
                                    onChange={this.handleTypeAheadChange('rejection_reasons_id')}
                                    ref="_handleSearch"
                                    selected={this.state.indiceRejection !== -1 ?
                                        [this.state.rejection_reasons[this.state.indiceRejection]]
                                        : []}
                                    delay={600}
                                    paginationText="Mostrar mas resultados..." />

                                :

                                <input className="form-control" name="rejection_description"
                                    id="rejection_description" step="0.01" type="text" min="0"
                                    //disabled={(!this.props.task_register.create && 
                                    //!this.props.task_register.update)||this.state.exist_extraction}
                                    onChange={this.handleChangeInput} value={this.state.rejection_description}
                                    required={this.state.don_abr_rech.value === "YES"
                                        || this.state.valoration === 'NO_APTO' || this.state.valoration === 'NOT_RESULTS'} />}
                        </div>
                        <div className="col-xs-12 col-sm-1">
                            <span className="size-min">Tipo</span>
                            <input
                                className="form-control" name="donation_status" id="donation_status"
                                disabled value={this.state.donation_status === "REJECT" ? 'PERMANENTE' :
                                    this.state.donation_status === 'DIFERIDO' ? 'DIFERIDO' : ""} />
                        </div>
                        {this.state.donation_status === "REJECT" && this.state.rejection_type !== "" ?
                            <div style={{ padding: "0px" }}>
                                <div className="col-xs-12 col-md-1" style={{ padding: "2px 2px 2px 8px" }}>
                                    <span className="size-min">{t('content.modal_hc.rejection_type')}</span>
                                    <input
                                        className="form-control" name="rejection_type" id="rejection_type"
                                        disabled value={this.state.rejection_type === 0 ? 'PERMANENTE' :
                                            this.state.rejection_type === 1 ? 'TEMPORAL' :
                                                this.state.rejection_type === 2 ? 'INDEFINIDO' :
                                                    ''} />
                                </div>
                            </div>
                            : null}
                        {this.state.donation_status === "DIFERIDO" ?
                            <div style={{ padding: "0px" }}>
                                <div className="col-xs-12 col-md-2" style={{ padding: "0" }}>
                                <b> <span className="size-min" style={{ fontSize: '13px' }}>{t('content.modal_hc.rejection_days')}(*)</span></b>
                                    <input className="form-control" name="rejection_days" id="rejection_days" step="0.01"
                                        type="number" min="0"
                                        //disabled={ this.state.DON_EDIT_REJECT_DAYS || (this.state.DON_EDIT_REJECT_DAYS && ((!this.props.task_clinic_history.create && !this.props.task_clinic_history.update)||this.state.exist_extraction) ) }
                                        onChange={this.handleChangeInput} value={this.state.rejection_days}
                                        onKeyUp={this.keyUpRejectionDay}
                                        required={this.state.donation_status === "DIFERIDO"} />
                                </div>

                                <div className="col-xs-12 col-md-2" style={{ padding: "0px 8px" }}>
                                    <span className="size-min">{t('content.modal_hc.next_donation')}</span>
                                    <input className="form-control hour-input" name="date" id="date" type="date"
                                        disabled
                                        onChange={this.calculateRefusalDays} value={this.state.date}
                                        required={this.state.donation_status === "DIFERIDO"} />
                                </div>
                            </div>

                            : null}

                    </div>
                    : null}
            </div></>
        );
    }
    
}

export default translate('translations')(RejectionReason);